// Vuetify
import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.css'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

// Vue
import { createApp } from 'vue'
import CategoryShowPage from '@components/CategoryShowPage.vue'

// Vuetify configuration
const vuetify = createVuetify({
  components,
  directives,
  icons: {
    defaultSet: 'mdi',
  },
  theme: {
    defaultTheme: 'light',
  },
})

// Mount CategoryShowPage to #category-show-app mount point
function mountCategoryShowApp() {
  const el = document.getElementById('category-show-app')
  if (el && !el.__vue_app__) {
    // Get data attributes passed from Rails
    const categoryData = el.dataset.category ? JSON.parse(el.dataset.category) : {}
    const categoriesData = el.dataset.categories ? JSON.parse(el.dataset.categories) : []
    const docsData = el.dataset.docs ? JSON.parse(el.dataset.docs) : []
    const paginationData = el.dataset.pagination ? JSON.parse(el.dataset.pagination) : {}
    const translations = el.dataset.translations ? JSON.parse(el.dataset.translations) : {}
    const locale = window.location.pathname.split('/')[1] || 'en'
    const searchPath = el.dataset.searchPath || '/' + locale + '/result'
    const knowledgebasePath = el.dataset.knowledgebasePath || '/' + locale + '/knowledgebase'

    const app = createApp(CategoryShowPage, {
      categoryData,
      categoriesData,
      docsData,
      paginationData,
      translations,
      searchPath,
      knowledgebasePath
    })

    app.use(vuetify)
    app.mount('#category-show-app')
  }
}

// Mount on DOM ready (for initial page load)
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mountCategoryShowApp)
} else {
  mountCategoryShowApp()
}

// For Turbolinks support
document.addEventListener('turbolinks:load', mountCategoryShowApp)

// Clean up on Turbolinks navigation
document.addEventListener('turbolinks:before-visit', () => {
  const el = document.getElementById('category-show-app')
  if (el && el.__vue_app__) {
    el.__vue_app__.unmount()
    delete el.__vue_app__
  }
})
